var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIco(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_137",
    "data-name": "Trazado 137",
    d: "M21.542-16H.94a.94.94,0,0,0-.94.94V-.589A.94.94,0,0,0,.275.075.94.94,0,0,0,.94.351h20.6a.94.94,0,0,0,.665-.275.94.94,0,0,0,.275-.665V-15.06a.94.94,0,0,0-.275-.665A.94.94,0,0,0,21.542-16Zm-1.38,1.359L12.488-6.976H9.994L2.32-14.641ZM1.359-1.008V-13.68L9.422-5.607H13.06l8.063-8.073V-1.008Z",
    transform: "translate(0 16)",
    fill: "#001e50"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-iconos_menu_flotante"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconos_menu_flotante",
    clipPath: "url(#clip-iconos_menu_flotante)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_mail",
    transform: "translate(0.759 3.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_186",
    "data-name": "Grupo 186",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_136",
    "data-name": "Trazado 136",
    d: "M-5-21H27.7V5.57H-5Z",
    transform: "translate(-0.11 15.89)",
    fill: "#001e50"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIco);
export default __webpack_public_path__ + "static/media/mail_ico.1abbb44ae81593d3c42b359017658c59.svg";
export { ForwardRef as ReactComponent };